module.exports = __webpack_public_path__ + "img/facebook-arica.fe691669.png";